import routes from '@routes';
import { useDossiersStore } from '@stores/useDossiersStore';

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path === `/${routes.myRequests}`) {
    return navigateTo('/');
  }

  if (to.path.startsWith('/properties')) {
    const { setSearchedTerm, setDossiers } = useDossiersStore();
    const { searchedDossiers } = toRefs(useDossiersStore());
    const propertyId = to.path.split('/')[2];

    if (!propertyId || isNaN(propertyId)) {
      return navigateTo(`/${routes.myRequests}`);
    };

    setSearchedTerm(propertyId);
    await setDossiers();

    if (searchedDossiers.value.length === 0) {
      return navigateTo(`/${routes.myRequests}`);
    }

    return navigateTo(`/${routes.myRequests}/${searchedDossiers.value?.[0]?.id ?? ''}`);
  }
});
